(function () {
  'use strict';

  var MAX_ITEMS = 3;

  document.querySelectorAll('[data-mmb]').forEach(initBundle);

  function initBundle(root) {
    var tiers = {
      2: parseFloat(root.dataset.tier2 || '0'),
      3: parseFloat(root.dataset.tier3 || '0')
    };

    var overlay = root.querySelector('[data-mmb-overlay]');
    var drawer = root.querySelector('[data-mmb-drawer]');
    var openBtns = root.querySelectorAll('[data-mmb-open]');
    var closeBtn = root.querySelector('[data-mmb-close]');
    var checkoutBtn = root.querySelector('[data-mmb-checkout]');
    var subtotalEl = root.querySelector('[data-mmb-subtotal]');
    var totalEl = root.querySelector('[data-mmb-total]');
    var itemsLabelEl = root.querySelector('[data-mmb-items-label]');
    var progressHintEl = root.querySelector('[data-mmb-progress-hint]');
    var discountRowEl = root.querySelector('[data-mmb-discount-row]');
    var discountLabelEl = root.querySelector('[data-mmb-discount-label]');
    var discountAmountEl = root.querySelector('[data-mmb-discount-amount]');

    // selections keyed by variant id: { variantId: { qty, price, card } }
    var selections = {};

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        overlay.hidden = false;
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    function closeDrawer() {
      overlay.hidden = true;
      drawer.hidden = true;
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-mmb-card]').forEach(function (card) {
      var addBtn = card.querySelector('[data-mmb-add]');
      var stepper = card.querySelector('[data-mmb-stepper]');
      var qtyEl = card.querySelector('[data-mmb-qty]');
      var minusBtn = card.querySelector('[data-mmb-minus]');
      var plusBtn = card.querySelector('[data-mmb-plus]');
      var swatches = card.querySelectorAll('[data-mmb-swatch]');
      var priceEl = card.querySelector('[data-mmb-card-price]');
      var imageEl = card.querySelector('[data-mmb-card-image] img');
      var activeVariantId = card.dataset.variantId;

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (card.classList.contains('is-selected')) return; // lock swatch once added; remove from bundle to change it
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
          activeVariantId = swatch.dataset.variantId;
          card.dataset.variantId = activeVariantId;
          card.dataset.price = swatch.dataset.price;
          if (priceEl) priceEl.textContent = formatMoney(parseFloat(swatch.dataset.price));
          if (imageEl && swatch.dataset.image) imageEl.src = swatch.dataset.image;
        });
      });

      addBtn.addEventListener('click', function () {
        if (totalItems() >= MAX_ITEMS) return; // hard cap — button should already be disabled
        var price = parseFloat(card.dataset.price || '0');
        selections[activeVariantId] = { qty: 1, price: price, card: card };
        addBtn.hidden = true;
        stepper.hidden = false;
        qtyEl.textContent = '1';
        card.classList.add('is-selected');
        recalculate();
      });

      plusBtn.addEventListener('click', function () {
        if (totalItems() >= MAX_ITEMS) return; // hard cap — button should already be disabled
        selections[activeVariantId].qty += 1;
        qtyEl.textContent = selections[activeVariantId].qty;
        recalculate();
      });

      minusBtn.addEventListener('click', function () {
        selections[activeVariantId].qty -= 1;
        if (selections[activeVariantId].qty <= 0) {
          delete selections[activeVariantId];
          stepper.hidden = true;
          addBtn.hidden = false;
          card.classList.remove('is-selected');
        } else {
          qtyEl.textContent = selections[activeVariantId].qty;
        }
        recalculate();
      });
    });

    function totalItems() {
      return Object.keys(selections).reduce(function (sum, id) {
        return sum + selections[id].qty;
      }, 0);
    }

    function subtotal() {
      return Object.keys(selections).reduce(function (sum, id) {
        return sum + selections[id].qty * selections[id].price;
      }, 0);
    }

    function tierAmountFor(count) {
      if (count >= 3) return tiers[3];
      if (count === 2) return tiers[2];
      return 0;
    }

    function formatMoney(amount) {
      return amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' EGP';
    }

    function updateTierChips(count) {
      root.querySelectorAll('[data-mmb-tier-chip]').forEach(function (chip) {
        var n = parseInt(chip.dataset.mmbTierChip, 10);
        var reached = n === 3 ? count >= 3 : count >= n;
        chip.classList.toggle('is-active', reached);
      });
    }

    function updateProgressHint(count, amount) {
      if (!progressHintEl) return;
      if (count === 0) {
        progressHintEl.textContent = '';
      } else if (count >= MAX_ITEMS) {
        progressHintEl.textContent = "You've unlocked " + tiers[3] + ' EGP off — maximum ' + MAX_ITEMS + ' items per bundle';
      } else {
        var nextTier = count + 1;
        var nextAmount = tierAmountFor(nextTier);
        progressHintEl.textContent = 'Add ' + (nextTier - count) + ' more to save ' + nextAmount + ' EGP';
      }
    }

    // Disables every "Add to bundle" and "+" button once the cap is
    // reached, so the customer physically cannot add a 4th item.
    // Re-enables them automatically once an item is removed.
    function updateMaxState(count) {
      var atMax = count >= MAX_ITEMS;
      root.querySelectorAll('[data-mmb-card]').forEach(function (card) {
        var addBtn = card.querySelector('[data-mmb-add]');
        var plusBtn = card.querySelector('[data-mmb-plus]');
        var isSelected = card.classList.contains('is-selected');

        if (addBtn && !isSelected) {
          addBtn.disabled = atMax;
        }
        if (plusBtn && isSelected) {
          plusBtn.disabled = atMax;
        }
      });
    }

    function recalculate() {
      var count = totalItems();
      var sub = subtotal();
      var discountAmount = tierAmountFor(count);
      var discounted = Math.max(0, sub - discountAmount);

      if (itemsLabelEl) itemsLabelEl.textContent = count + (count === 1 ? ' item' : ' items');
      if (subtotalEl) subtotalEl.textContent = formatMoney(sub);
      if (totalEl) totalEl.textContent = formatMoney(discounted);

      if (discountRowEl) {
        if (discountAmount > 0) {
          discountRowEl.hidden = false;
          if (discountLabelEl) discountLabelEl.textContent = 'Discount';
          if (discountAmountEl) discountAmountEl.textContent = '-' + formatMoney(sub - discounted);
        } else {
          discountRowEl.hidden = true;
        }
      }

      updateTierChips(count);
      updateProgressHint(count, discountAmount);
      updateMaxState(count);

      if (count < 1) {
        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'Add at least 1 item';
      } else if (discountAmount === 0) {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Add bundle to cart';
      } else {
        checkoutBtn.disabled = false;
        var savedAmount = sub - discounted;
        checkoutBtn.textContent = 'Add bundle to cart · Save ' + formatMoney(savedAmount);
      }
    }

    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.disabled) return;
      var items = Object.keys(selections).map(function (variantId) {
        return { id: variantId, quantity: selections[variantId].qty };
      });

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          closeDrawer();
          window.location.href = '/cart';
        })
        .catch(function () {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'Something went wrong — try again';
        });
    });
  }
})();